import * as Yup from 'yup';

export const validateionSchema = Yup.object().shape({
  email: Yup.string().email().required(),
});
